import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const footerColumns = [
  {
    title: "Footwear",
    items: categories.filter((_, i) => i === 0),
  },
  {
    title: "Apparel",
    items: categories.filter((_, i) => i >= 1 && i <= 6),
  },
  {
    title: "Accessories",
    items: categories.filter((_, i) => i >= 7 && i <= 12),
  },
  {
    title: "More",
    items: categories.filter((_, i) => i >= 13),
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h3 className="text-xs tracking-widest uppercase text-foreground-500 mb-4 font-label">
                {col.title}
              </h3>
              <div className="w-8 h-px bg-background-300 mb-4"></div>
              <ul className="space-y-2.5">
                {col.items.map((item) => (
                  <li key={item.slug}>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-background-200/60 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <Link to="/" className="flex items-center gap-2 cursor-pointer group">
              <span className="text-2xl tracking-tight text-foreground-900 font-heading">
                PANDABUY
              </span>
              <span className="text-2xl tracking-tight text-primary-500 font-heading">
                CASA
              </span>
            </Link>
            <div className="w-12 h-px bg-background-300 mt-2"></div>
            <p className="text-xs text-foreground-500 mt-2">
              Your curated pandabuyspreadsheet directory hub
            </p>
          </div>

          <div className="flex flex-col items-start md:items-end gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} pandabuy.casa
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer"
                aria-label="Main Website"
              >
                <i className="ri-external-link-line text-lg"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer"
                aria-label="Spreadsheet Hub"
              >
                <i className="ri-file-list-3-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}